export default "__VITE_ASSET__C$X$K4e3__"